import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Col, Clearfix } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';
import { find as _find, omit as _omit } from 'lodash';

import { getThumbFile } from 'helpers/items';
import { getElementTypes } from 'helpers/cms';

import Loader from 'components/layout/Loader';

import List from 'components/List';

class CmsPageQuickPageBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedType: null,
    };
  }

  toggleType = (e, newSelectedType) => {
    e.preventDefault();
    this.setState(prevState => ({ selectedType: prevState.selectedType === newSelectedType ? null : newSelectedType }));
  };

  addElement = (e, dynamicElement) => {
    e.preventDefault();
    const { page, addCmsElements } = this.props;

    const language = page.language || page.getLanguage();
    const dynamicElementContent = _find(dynamicElement.content, { language });

    const data = dynamicElementContent.content.map(content => {
      return _omit(content, ['id']);
    });

    addCmsElements(data);
  };

  close = e => {
    e.preventDefault();

    const { close } = this.props;
    close();
  };

  render() {
    const {
      intl: { messages },
      open,
      page,
      dynamicElements,
    } = this.props;
    const { selectedType } = this.state;

    const language = open && (page.language || page.getLanguage());

    return (
      <div className={open ? '' : 'hide'}>
        {getElementTypes(messages).map(elementType => {
          const selected = selectedType === elementType.value;

          return (
            <div key={elementType.value}>
              <Clearfix
                className={
                  'cursor padding-15 ' + (selected ? 'bg-master-lightest b-l-thick b-primary' : 'bg-white b-b b-grey')
                }
                onClick={e => this.toggleType(e, elementType.value)}
              >
                <div className={'pull-left bold ' + (selected ? 'text-primary ' : '')}>{elementType.label}</div>
                <div className="pull-right p-r-10">
                  <i
                    className={
                      selected ? 'fad fa-chevron-circle-up text-primary' : 'fal fa-chevron-circle-down hint-text'
                    }
                    style={{ transform: 'scale(1.5)' }}
                  />
                </div>
              </Clearfix>

              {selected && (
                <AnimateHeight
                  duration={500}
                  height={selected ? 'auto' : 0}
                  className="bg-master-lightest b-l-thick b-primary"
                >
                  <div className="p-l-15 p-r-15 p-b-15 b-b b-grey">
                    <List
                      noRender
                      listName="dynamicElements"
                      url="/api/dynamicelements.json"
                      list={dynamicElements}
                      urlData={{ filters: { type: elementType.value }, isReference: false }}
                    />

                    {!dynamicElements.pending ? (
                      <Clearfix>
                        {!dynamicElements.data.count && messages.no_results_found}

                        {dynamicElements.data.list.map(dynamicElement => {
                          const { id, name, preview } = dynamicElement;
                          const dynamicElementContent = _find(dynamicElement.content, { language });

                          if (dynamicElementContent) {
                            let previewThumb;
                            if (preview) {
                              previewThumb = getThumbFile(preview);
                            }

                            return (
                              <Col xs={6} key={id}>
                                <a
                                  href="#selectElement"
                                  onClick={e => this.addElement(e, dynamicElement)}
                                  className="block m-b-15 bg-white b-rad-lg b-a b-grey text-master"
                                >
                                  <h6 className="overflow-ellipsis bold no-margin p-t-10 p-l-10 p-r-5">{name}</h6>

                                  <span
                                    className="relative block"
                                    style={{
                                      paddingTop: '80%',
                                      width: '100%',
                                    }}
                                  >
                                    {previewThumb ? (
                                      <div
                                        className="top-left bottom-right"
                                        style={{
                                          backgroundImage: 'url(' + previewThumb.web_link + ')',
                                          backgroundSize: 'contain',
                                          backgroundRepeat: 'no-repeat',
                                          backgroundPosition: 'center',
                                        }}
                                      />
                                    ) : (
                                      <i
                                        class="fad fa-square-full fa-3x text-master-light hint-text"
                                        style={{
                                          position: 'absolute',
                                          top: '50%',
                                          left: '50%',
                                          transform: 'translate(-50%, -50%)',
                                        }}
                                      />
                                    )}
                                  </span>
                                </a>
                              </Col>
                            );
                          }

                          return null;
                        })}
                      </Clearfix>
                    ) : (
                      <Loader />
                    )}
                  </div>
                </AnimateHeight>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}
CmsPageQuickPageBuilder.defaultProps = {
  open: false,
  page: {},
  close: () => {},
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    dynamicElements: state.list.dynamicElements,
  };
};

export default injectIntl(connect(mapStateToProps)(CmsPageQuickPageBuilder));
